import { Component } from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { LANG_STORAGE_KEY } from '../../../app';

@Component({
  selector: 'app-language-toggle',
  standalone: true,
  imports: [MatButtonToggleModule, TranslatePipe],
  template: `
    <mat-button-toggle-group
      [value]="currentLang"
      (change)="switchLang($event.value)"
      class="lang-toggle"
    >
      <mat-button-toggle value="hi">{{ 'LANGUAGE.HI' | translate }}</mat-button-toggle>
      <mat-button-toggle value="en">{{ 'LANGUAGE.EN' | translate }}</mat-button-toggle>
    </mat-button-toggle-group>
  `,
  styles: [`
    .lang-toggle {
      ::ng-deep .mat-button-toggle-appearance-standard {
        background: rgba(255, 255, 255, 0.15);
        color: white;
        border-color: rgba(255, 255, 255, 0.3);
        min-height: 36px;
        font-size: 0.8125rem;
      }

      ::ng-deep .mat-button-toggle-checked {
        background: rgba(255, 255, 255, 0.3) !important;
        font-weight: 600;
      }
    }
  `],
})
export class LanguageToggleComponent {
  currentLang: string;

  constructor(private translate: TranslateService) {
    this.currentLang = translate.currentLang || 'hi';
  }

  switchLang(lang: string): void {
    this.currentLang = lang;
    this.translate.use(lang);
    // Persist so reloads (and freshly opened tabs sharing localStorage)
    // honour the citizen's last choice — see app.ts for the read path.
    try { localStorage.setItem(LANG_STORAGE_KEY, lang); } catch { /* private mode */ }
  }
}
